<template>
  <div class="slider-title">
    <div v-if="!hideCloseButton" class="close-panel has-text-right" @click="closePanel"><i class="fal fa-times close-icon"></i></div>
    <div>{{ title }}</div>
    <div class="sub-title" v-if="subTitle">{{ subTitle }}</div>
    <div class="close-panel actions"><slot /></div>
  </div>
</template>
<script>

export default {
  props: {
    title: String,
    subTitle: String,
    hideCloseButton: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    closePanel: function () {
      this.$parent.$emit('closePanel')
    }
  },
  created () {
    this.$on('emitSave', () => {
      this.$parent.$emit('emitSave')
    })
    this.$on('closePanel', () => {
      this.$parent.$emit('closePanel')
    })
  }
}
</script>
<style lang="scss" scoped>
  // @import '~@/assets/styles/common/common';
  .sub-title {
    font-size: 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/modals/ModalLayoutTop.vue